import { toast } from "sonner";

/** What a non-member is told instead of being sent to a Google Group that
 *  turns them away. The sidebar's Discussion item and the welcome page's
 *  Discussion heading both say it, so it is said once, here. */
export function sayListservIsForMembers(navigate: (to: string) => void) {
  toast("The AFELL listserv is for members", {
    description: "It is a Google Group run by Soft Network. Membership is by application.",
    action: { label: "Apply", onClick: () => navigate("/apply") },
  });
}
